import React from 'react';
import { VoxelDialog } from '@wikifactory/voxel-ui';
import { Trans } from 'react-i18next';
import Button from 'components/Button';

export type ConfirmModalProps = {
  title?: string;
  titleStyle?: React.CSSProperties;
  content?: React.ReactNode;
  titleClassName?: string;
  open: boolean;
  loading?: boolean;
  onClose?: () => void;
  onConfirm: () => void;
  style?: React.CSSProperties;
  paperStyle?: React.CSSProperties;
  contentProps?: Record<string, any>;
};

export const ConfirmModal = ({
  title,
  open,
  loading,
  onClose,
  onConfirm,
  paperStyle,
  style = {},
  titleStyle,
  titleClassName = '',
  contentProps,
  content,
}: ConfirmModalProps) => {
  return (
    <VoxelDialog
      open={open}
      disableEscapeKeyDown
      PaperProps={{
        sx: paperStyle,
      }}
      contentProps={contentProps}
      style={{
        // Promise level more than subheader component zIndex.
        zIndex: 1000000,
        ...style,
      }}
      actions={
        <>
          <Button
            size='small'
            variant='transparent'
            data-testid='cancel'
            text='Cancel'
            className='border'
            onClick={onClose}
          />
          <Button
            size='small'
            data-testid='confirm'
            text='Confirm'
            outline
            loading={loading}
            onClick={onConfirm}
          />
        </>
      }
    >
      {content || (
        <h2
          className={`font-extrabold text-24 text-black flex flex-nowrap ${titleClassName}`}
          style={titleStyle}
        >
          <Trans>{title}</Trans>
        </h2>
      )}
    </VoxelDialog>
  );
};
